import { onKeyStroke } from '@vueuse/core';
import { useStableWindowSize } from '@/composition/use-stable-window-size';

export interface IReservationsShortcutsOptions {
  enabled: () => boolean;
  isTodayTab: () => boolean;
  openForm: () => void;
  openWalkIn: () => void;
  focusSearch: () => void;
  shiftDate: (days: -1 | 1) => void;
  goToday: () => void;
}

function isEditable(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) ||
      target.isContentEditable)
  );
}

export function useReservationsShortcuts(
  options: IReservationsShortcutsOptions
): () => void {
  const { width } = useStableWindowSize();

  return onKeyStroke(
    ['n', 'N', 'w', 'W', '/', 't', 'T', 'ArrowLeft', 'ArrowRight'],
    (event) => {
      if (
        !options.enabled() ||
        width.value < 1024 ||
        event.defaultPrevented ||
        event.isComposing ||
        event.ctrlKey ||
        event.altKey ||
        event.metaKey ||
        (event.shiftKey && event.key !== '/') ||
        typeof document === 'undefined' ||
        isEditable(document.activeElement) ||
        isEditable(event.target) ||
        document.querySelector('[role="dialog"], .vm--container')
      )
        return;

      let action: (() => void) | undefined;
      switch (event.key.toLowerCase()) {
        case 'n':
          action = options.openForm;
          break;
        case 'w':
          action = options.openWalkIn;
          break;
        case '/':
          action = options.focusSearch;
          break;
        case 't':
          action = options.goToday;
          break;
        case 'arrowleft':
          if (options.isTodayTab()) action = () => options.shiftDate(-1);
          break;
        case 'arrowright':
          if (options.isTodayTab()) action = () => options.shiftDate(1);
          break;
      }
      if (!action) return;
      event.preventDefault();
      action();
    },
    {
      target: () => (typeof window === 'undefined' ? undefined : window),
      dedupe: true,
    }
  );
}
